
import { Expose, Type } from 'class-transformer'
import { IsArray, IsDefined, IsNumber, IsOptional, ValidateNested } from 'class-validator'

export class GetEventsStatisticsDTO {

    @Expose()
    @IsDefined()
    @IsNumber()
    eventAttendanceCount!: number 

    @Expose()
    @IsDefined()
    @IsArray()
    eventAttendanceXAxis!: [] 

    @Expose()
    @IsDefined()
    @IsArray()
    eventAttendanceData!: [] 

}